'use client';
import './business.css';
import BusinessConsultTimeline from '@/components/BusinessConsultTimeline';
import Data5 from '../../textContent/erp-bangalore/data.json';
import FaqQuestions from '@/components/FaqQuestions';
import FeaturesCard from '@/components/FeaturesCard';
import { Fragment } from 'react';
import HomeBlog from '@/components/HomeBlog';
import HomeCaseStudies from '@/components/HomeCaseStudies';
import ScrollableIcons from '@/components/ScrollableIcons';
import ServicesHero from '@/components/ServicesHero';
import featuresCardData from '@/textContent/index/featuresCardData.json';
import { motion } from 'framer-motion';
import scrollableIconsData from '@/textContent/index/scrollableIconsData.json';

/* ---------------- Animation Variants ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: 'easeOut' },
    },
};

const fadeLeft = {
    hidden: { opacity: 0, x: -40 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.6, ease: 'easeOut' },
    },
};

const fadeRight = {
    hidden: { opacity: 0, x: 40 },
    visible: {
        opacity: 1,
        x: 0,
        transition: { duration: 0.6, ease: 'easeOut' },
    },
};

const Page = () => {
    return (
        <Fragment>
            {/* ---------------- Hero ---------------- */}
            <motion.div initial="hidden" animate="visible" variants={fadeUp}>
                <ServicesHero data={Data5} />
            </motion.div>

            {/* ---------------- Mission Section ---------------- */}
            <motion.div
                id="ourmission"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                className="md:flex md:w-full md:py-[5vw] md:pl-[10vw]"
            >
                {/* Left */}
                <motion.div
                    variants={fadeLeft}
                    className="md:p-0 p-[8vw] md:max-w-[40%]"
                >
                    <motion.p
                        variants={fadeUp}
                        className="text-blue-700 font-semibold md:text-xs text-lg uppercase tracking-widest"
                    >
                        Mission
                    </motion.p>

                    <motion.p
                        variants={fadeUp}
                        className="md:text-4xl text-3xl font-extrabold md:mt-2 mt-[4vw] text-[#292D34]"
                    >
                        Do you struggle with operational inefficiencies and
                        complicated accounting?
                    </motion.p>

                    <motion.div
                        variants={fadeUp}
                        className="border-2 border-blue-500 rounded-3xl md:w-[5vw] w-[22vw] md:mt-[1vw] mt-[3vw]"
                    />

                    <motion.p
                        variants={fadeUp}
                        className="md:mt-4 mt-[12vw] opacity-60"
                    >
                        You are not the only one.
                        <br />
                        At Wahni IT Solutions, as one of the leading providers
                        of ERP in Bangalore, we help companies improve accuracy,
                        compliance, and speed.
                    </motion.p>
                </motion.div>

                {/* Right */}
                <motion.div
                    variants={fadeRight}
                    className="md:w-[50%] flex items-center justify-center"
                >
                    <motion.p
                        whileHover={{ scale: 1.05 }}
                        transition={{ type: 'spring', stiffness: 200 }}
                        className="text-5xl font-bold bg-white rounded-2xl p-10 shadow-2xl"
                    >
                        Better <br />
                        <span className="text-purple-600 font-extrabold">
                            Financial <br /> Understanding
                        </span>
                        <br /> and <br />
                        <span className="text-purple-600 font-extrabold">
                            Operational <br /> Efficiency
                        </span>
                    </motion.p>
                </motion.div>
            </motion.div>

            {/* ---------------- Timeline ---------------- */}
            <motion.div
                id="timeline"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeUp}
                className="flex flex-col items-center px-5"
            >
                <motion.p
                    variants={fadeUp}
                    className="md:text-4xl text-2xl font-bold md:pb-28 pt-20 pb-10 text-center"
                >
                    Better Financial Understanding and <br />
                    Operational Efficiency
                </motion.p>

                <BusinessConsultTimeline />
            </motion.div>

            {/* ---------------- Scrollable Icons ---------------- */}
            <motion.section
                id="iconss"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                className="w-full bg-gray-50 py-20 mt-20"
            >
                <div className="max-w-7xl mx-auto px-6">
                    <ScrollableIcons data={scrollableIconsData} />
                </div>
            </motion.section>

            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <FeaturesCard data={featuresCardData} />
            </motion.div>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <FaqQuestions />
            </motion.div>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <HomeBlog />
            </motion.div>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <HomeCaseStudies />
            </motion.div>
        </Fragment>
    );
};

export default Page;
